<template>
    <div class="flex h-48 w-100 justify-center items-center">
        <img :src="'/img/icons/loading.svg'"  alt="loading"/>
    </div>
</template>
